import { render, staticRenderFns } from "./ProfitabilityReport.vue?vue&type=template&id=4447ca5a&scoped=true"
import script from "./ProfitabilityReport.vue?vue&type=script&lang=js"
export * from "./ProfitabilityReport.vue?vue&type=script&lang=js"
import style0 from "./ProfitabilityReport.vue?vue&type=style&index=0&id=4447ca5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4447ca5a",
  null
  
)

export default component.exports